import React from "react";
import { benefits } from "../data/content";
import { useLazyBackground } from "../hooks/useLazyBackground";
export function Benefits() {
  const [featured, ...rest] = benefits;
  const FeaturedIcon = featured.icon;
  const bg = useLazyBackground<HTMLElement>("https://cdn.magicpatterns.com/uploads/eSnsjHSzTj9s41an7ugcrK/A261EA7E-E313-428F-AE06-CA501475F6AC.png");
  return <section ref={bg.ref} className="bg-paper py-20 md:py-28" aria-labelledby="benefits-title" style={{
    backgroundImage: bg.backgroundImage,
    backgroundSize: "auto",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  }} data-id="element-16" data-mp="3qre0lyn04xnu">
      <div className="mx-auto max-w-6xl px-5 md:px-8" style={{
      backgroundColor: "#FBF7EE",
      backgroundImage: "none",
      backgroundSize: "auto",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat"
    }} data-id="element-17" data-mp="3hs0loqg3zgvq">
        <div className="max-w-2xl" data-id="element-18" data-mp="1fy9rk9656r01">
          <h2 id="benefits-title" className="font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-19" data-mp="1fx8ey09h9wg7">
            Lo que hoy parece complicado puede convertirse en un plan.
          </h2>
          <p className="mt-4 text-lg text-muted" data-id="element-20" data-mp="6st6pw9e05wb">Con esta guía vas a poder:</p>
        </div>

        <div className="mt-12 grid gap-4 md:grid-cols-2 lg:grid-cols-3 lg:grid-rows-3" data-id="element-21" data-mp="6qgi5094ixaa">
          <article className="flex flex-col rounded-3xl bg-ink p-8 text-cream md:col-span-2 lg:col-span-1 lg:row-span-3" style={{
          backgroundColor: "#1C3A55",
          backgroundImage: "none"
        }} data-id="element-22" data-mp="3p0iplycu7tne">
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-sun text-ink" data-id="element-23" data-mp="lk1s1t69b53n">
              <FeaturedIcon className="h-7 w-7" aria-hidden="true" data-id="element-24" data-mp="qildztkuogw0" />
            </span>
            <h3 className="mt-8 font-display text-3xl font-semibold leading-tight md:text-4xl" data-id="element-25" data-mp="bps0uet1wcui">
              {featured.title}
            </h3>
            <p className="mt-4 text-lg leading-relaxed text-cream/80" data-id="element-26" data-mp="14g1mrbqmcmqx">{featured.text}</p>
            <p className="mt-auto pt-10 text-sm font-bold text-cream" data-id="element-27" data-mp="197084pqgsb11">
              13 módulos · paso a paso
            </p>
          </article>

          {rest.map(({
          icon: Icon,
          title,
          text
        }) => <article key={title} className="flex gap-4 rounded-3xl bg-white p-6 ring-1 ring-line" data-id="element-28" data-mp="1e3nnubzebryb">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-mint text-ink" style={{
            backgroundColor: "#FFC72C",
            backgroundImage: "none"
          }} data-id="element-29" data-mp="194b4w2bnb510">
                <Icon className="h-5 w-5" aria-hidden="true" data-id="element-30" data-mp="104o2bd76jt6d" />
              </span>
              <div data-id="element-31" data-mp="vdxvdvj3vi9k">
                <h3 className="font-bold leading-snug text-ink" data-id="element-32" data-mp="vdebi99wajsw">{title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-33" data-mp="qebijn76w41a">{text}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}